import fetcher from 'api/fetcher';
import { CLICKME_LINK_PROMO } from 'utils/constants/app';

const sessionLogout = (): void => {
    void fetcher.get('/api/v1/session/logout').then(() => {
        window.location.href = CLICKME_LINK_PROMO;
    });
};

export default sessionLogout;
